export const baseClubFields = [
  'id',
  'name',
  'username',
  'profileImageBlobHash',
  'canEdit',
  'isFollowed',
  'ownerId',
  'clubType',
  'updatedAt',
];

export const detailClubFields = [
  ...baseClubFields,
  'owner',
  'organizers',
  'gambits',
  'distance',
  'homeLocations',
  'headquarters',
  'description',
  'gambitCount',
  'upcomingCount',
  'followerCount',
  'handshakes',
];
